/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ApplicationInsightsPolicyModule
 * @preferred
 */

import angular from 'angular';
import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';

import {
    APPLICATION_INSIGHTS_PARAMS_CONFIG_ITEM,
    APPLICATION_INSIGHTS_POLICY_COLLECTION_TOKEN,
    APPLICATION_INSIGHTS_POLICY_ITEM_TOKEN,
    APPLICATION_SAMPLING_CONFIG_CONFIG_ITEM,
} from './application-insights-policy.tokens';

import { ApplicationInsightsPolicyItem } from './factories/application-insights-policy.item.factory';
import { ApplicationInsightsPolicyCollection } from './factories/application-insights-policy.collection.factory';
import { ApplicationSamplingConfigConfigItem } from './factories/application-sampling-config.config-item.factory';
import { ApplicationInsightsParamsConfigItem } from './factories/application-insights-params.config-item.factory';

const applicationInsightsPolicyModule = angular.module('avi/application-insights-policy');

const factories = [
    {
        factory: ApplicationSamplingConfigConfigItem,
        name: APPLICATION_SAMPLING_CONFIG_CONFIG_ITEM,
    },
    {
        factory: ApplicationInsightsParamsConfigItem,
        name: APPLICATION_INSIGHTS_PARAMS_CONFIG_ITEM,
    },
    {
        factory: ApplicationInsightsPolicyItem,
        name: APPLICATION_INSIGHTS_POLICY_ITEM_TOKEN,
    },
    {
        factory: ApplicationInsightsPolicyCollection,
        name: APPLICATION_INSIGHTS_POLICY_COLLECTION_TOKEN,
    },
];

factories.forEach(({ name, factory }) => {
    initAjsDependency(applicationInsightsPolicyModule, 'factory', name, factory);
});
